import { MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";
import { CodedProperty, LabeledText, Stack, Text } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../common/types/Language";

type SubtitleItem = {
    targetFilename?: string;
    isEmbedded?: boolean;
    language: CodedProperty;
};

type SubtitlesTargetFileNameListProps = {
    subtitles: Array<SubtitleItem>;
};

export const SubtitlesTargetFileNameList = ({ subtitles }: SubtitlesTargetFileNameListProps): JSX.Element => {
    const subtitlesWithTargetFileName = subtitles.filter((subtitle) => !!subtitle.targetFilename);

    const uniqueSubtitlesMap: Record<string, SubtitleItem> = {};
    subtitlesWithTargetFileName.forEach((subtitle) => {
        const languageId = subtitle.language.id;
        if (!uniqueSubtitlesMap[languageId]) {
            uniqueSubtitlesMap[languageId] = subtitle;
        }
        uniqueSubtitlesMap[languageId] = subtitle;
    });
    const uniqueSubtitles = Object.values(uniqueSubtitlesMap);

    return (
        <MessageBar messageBarType={MessageBarType.info} isMultiline={true}>
            <Stack>
                <Text styles={{ root: { fontWeight: 600, marginBottom: 10 } }} variant="small">
                    {"Origin order's subtitles target filenames"}
                </Text>
                {uniqueSubtitles.length ? (
                    uniqueSubtitles.map((subtitle, index) => (
                        <LabeledText
                            key={index}
                            direction="horizontal"
                            textFontSize={12}
                            labelFontSize={12}
                            labelFontWeight={"400"}
                            label={`${getLanguageDisplayName(subtitle.language)}:`}
                            value={subtitle.targetFilename}
                        />
                    ))
                ) : (
                    <Text variant="small">{"No subtitles with target filenames found."}</Text>
                )}
            </Stack>
        </MessageBar>
    );
};
